import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';
import { FMS_READ_SCOPE, fmsReadBasePath } from '#/api/fmsMgmt/fmsReadScope';

/** GET `/fms/payment-requests/{id}`（`.read`）或 `/fms/payment-requests/self/{id}`（`.self`） */
export async function fetchPaymentRequestDetail(id, { scope = FMS_READ_SCOPE.ALL } = {}) {
  const { data: raw } = await request.get(`${fmsReadBasePath('payment-requests', scope)}/${id}`);
  return parseVer4DetailResponse(raw);
}

/** GET `/fms/payment-requests/{id}/vouchers/{voucherId}`：由可見請款單讀取目前關聯的憑證 */
export async function fetchPaymentRequestVoucherDetail(id, voucherId) {
  const { data: raw } = await request.get(`/fms/payment-requests/${id}/vouchers/${voucherId}`);
  return parseVer4DetailResponse(raw);
}
